import { render } from "./home-page-landingonly.vue?vue&type=template&id=344c70e0"
const script = {}

import "./home-page-landingonly.vue?vue&type=style&index=0&id=344c70e0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__